import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AutoUserSchema, autoType } from '../types/autoUserSchema';
import { fetchUserAutoList } from '../services/fetchUserAutoList';
import { fetchDeleteUserAuto } from '../services/fetchDeleteUserAuto';

const initialState: AutoUserSchema = {
  listAuto: [],
  isLoadedListAuto: false,
  errorMessage: '',
  isError: null,
};

export const autoUserSlice = createSlice({
  name: 'autoUser',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(fetchUserAutoList.pending, state => {
      state.isLoadedListAuto = false;
    });
    builder.addCase(fetchUserAutoList.fulfilled, (state, action) => {
      if (action.payload) {
        state.listAuto = action.payload;
      }
      state.isLoadedListAuto = true;
    });
    builder.addCase(fetchUserAutoList.rejected, (state, action) => {
      state.isLoadedListAuto = true;
      state.isError = { code: action.payload.code };
      state.errorMessage = 'Ой ошибка :( Попробуйте еще раз.';
    });
    builder.addCase(fetchDeleteUserAuto.fulfilled, (state, action: PayloadAction<autoType>) => {
      state.listAuto = state.listAuto.filter(auto => auto.autoRn !== action.payload.autoRn);
    });
  },
});

export const { actions: autoUserActions } = autoUserSlice;
